<template>
  <v-container fluid tag="section">
    <div  v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-card-text class="pb-0 pt-0" v-for="(itm,idx) in item" :key="idx">
      <v-divider v-if="idx !== 0" class="my-4"></v-divider>
      <v-row>
        <v-col cols="12">
          <v-chip color="primary" small class="mr-3" outlined>
            {{itm.year}}年
          </v-chip>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4">
          资产总额(万元)：<span class="font-weight-black">{{itm.assets}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4">
          净资产额(万元)：<span class="font-weight-black">{{itm.netAssets}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 6 : 4">
          固定资产(万元)：<span class="font-weight-black">{{itm.fixedAssets}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :md="mini ? 6 : 4">
          营业收入(万元)：<span class="font-weight-black">{{itm.income}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4">
          主营收入(万元)：<span class="font-weight-black">{{itm.firstIncome}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4">
          利润总额(万元)：<span class="font-weight-black">{{itm.profit}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :md="mini ? 6 : 4">
          净利润额(万元)：<span class="font-weight-black">{{itm.netProfit}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4">
          研发费用(万元)：<span class="font-weight-black">{{itm.development}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4">
          研发占比：<span class="font-weight-black">{{itm.developmentRatio}}%</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerFinanceDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        form: {
          id: '',
          result: ''
        }
      }
    }
  }
</script>

<style>
</style>
